<template>
  <div>
    <div class="base center">
      <div class="date">{{ date }}</div>
    </div>
    <!-- <div :class="[ isMine ? 'right' : 'left']">
      <div class="base name text-ellipsis">
        <span v-if="!isMine">{{ message.nickname }}</span>
        <span :style="{'padding-left':'5px','float':isMine?'right':'none'}">{{message.showTime}}</span>  
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'MessageHeader',
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  methods:{
    formatDate(now) {
        var year = now.getFullYear()  //取得4位数的年份
        var month = now.getMonth() + 1  //取得日期中的月份，其中0表示1月，11表示12月
        var date = now.getDate()      //返回日期月份中的天数（1到31）
        var hour = (now.getHours() < 10) ? ('0' + now.getHours()) : now.getHours()     //返回日期中的小时数（0到23）
        var minute = (now.getMinutes() < 10) ? ('0' + now.getMinutes()) : now.getMinutes() //返回日期中的分钟数（0到59）
        var second = (now.getSeconds() < 10) ? ('0' + now.getSeconds()) : now.getSeconds() //返回日期中的秒数（0到59）
        //消息时间与今天零点零分做比较,今天以前的返回日期；今天的只显示时分秒
        var time = new Date(new Date().setHours(0, 0, 0, 0))
        if (now > time) {
            return hour + ':' + minute 
        } else {
            return year + '-' + month + '-' + date + ' ' + hour + ':' + minute 
        }
    }
  },
  computed: {
    ...mapState({
      currentConversation: state => state.conversation.currentConversation,
      currentUserProfile: state => state.user.currentUserProfile,
      currentMemberList: state => state.group.currentMemberList
    }),
    date() {
      this.message['showTime'] = this.formatDate(new Date(this.message.createTime))
      return this.message.formatTime
    },
    from() {
      const isC2C = this.currentConversation.type === this.TIM.TYPES.CONV_C2C
      // 自己发送的用昵称渲染
      if (this.isMine) {
        return this.currentUserProfile.nick || this.currentUserProfile.userID
      }
      // 1. C2C 的消息体中还无 nick / avatar 字段，需从 conversation.userProfile 中获取
      if (isC2C) {
        return (
          this.currentConversation.userProfile.nick ||
          this.currentConversation.userProfile.userID
        )
      } else if (this.currentConversation.type === this.TIM.TYPES.CONV_SYSTEM) {
        return this.message.type === this.TIM.TYPES.MSG_GRP_SYS_NOTICE
          ? '群系统通知'
          : '系统通知'
      }
      // 2. 群组消息，用消息体中的 nick 渲染。nameCard暂时支持不完善
      return this.message.nick || this.message.from
    },
    isMine() {
      // return this.message.flow === 'out'
      return this.message.sendFrom === this.TYPES.MSG_FROM.USER || this.message.sendFrom === this.TYPES.MSG_FROM.USER_SYSTEM
    }
  }
}
</script>

<style lang="stylus" scoped>
.right {
  display: flex;
  flex-direction: row-reverse;
}

.left {
  display: flex;
  flex-direction: row;
}

.center {
  display: block;
  text-align: center;
  margin-bottom: 10px;/*no*/
}

.base {
  color: $secondary;
  font-size: 12px;
}

.name {
  padding: 0 4px;/*no*/
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 5px;/*no*/
}
</style>
